import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useT } from "@/i18n";
import { Button } from "./ui/button";

/** A public navigation door, never an auth gate. Keep the capability tables
 *  out of the spectator's initial bundle; the login route checks again. */
export function AccountLink({ className }: { className?: string }) {
  const t = useT();
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => {
    let alive = true;
    void import("@/lib/session")
      .then(async ({ ensureSession, accountIdentity }) => {
        const state = await ensureSession();
        if (alive) setSignedIn(state.status === "active" && accountIdentity(state.info) !== null);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);
  return (
    <Button className={className} render={<Link to={signedIn ? "/account" : "/login"} />}>
      {t(signedIn ? "front.account" : "front.login")}
    </Button>
  );
}
